import React from "react";
import {SvgIcon, SvgIconProps} from "@material-ui/core"


const TimesIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props}>
            <svg version="1.1" id="Layer_1" x="0px" y="0px"
                 viewBox="0 0 512 512">
                <g>
                    <g id="Line_42">
                        <path fill="#E60000" d="M31.72,508.634c-7.454,0-14.907-2.841-20.599-8.543c-11.346-11.384-11.327-29.795,0.047-41.141
			L459.217,11.859c11.384-11.346,29.795-11.318,41.142,0.047c11.346,11.375,11.327,29.795-0.038,41.151L52.272,500.13
			C46.59,505.793,39.155,508.634,31.72,508.634z"/>
                    </g>
                    <g id="Line_42_1_">
                        <path fill="#E60000" d="M480.28,508.634c7.454,0,14.907-2.841,20.599-8.543c11.346-11.384,11.327-29.795-0.047-41.141
			L52.783,11.859C41.399,0.512,22.988,0.541,11.642,11.906C0.296,23.28,0.314,41.701,11.68,53.057L459.728,500.13
			C465.41,505.793,472.845,508.634,480.28,508.634z"/>
                    </g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
            </svg>
        </SvgIcon>
    )
};

export default TimesIcon;